export default [
  {
    id: 1,
    name: 'texts',
    path: '/texts',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'texts' },
    ]
  },
  {
    id: 2,
    name: 'users',
    path: '/users',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'users' },
    ]
  },
  {
    id: 13,
    name: 'sources',
    path: '/sources',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'sources' },
    ]
  },
  {
    id: 14,
    name: 'manage-sources',
    path: '/manage-sources',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'manage-sources' },
    ]
  },
  {
    id: 3,
    name: 'manage-texts',
    path: '/manage-texts',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'manage-texts' },
    ]
  },
  {
    id: 4,
    name: 'manage-text',
    path: '/manage-texts/text',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'manage-texts', link: '/manage-texts' },
    ]
  },
  {
    id: 5,
    name: 'cards',
    path: '/manage-texts/cards',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'manage-texts', link: '/manage-texts' },
    ]
  },
  {
    id: 17,
    name: 'other-transcripts',
    path: '/manage-texts/other-transcript',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'manage-texts', link: '/manage-texts' },
    ]
  },
  {
    id: 18,
    name: 'sources-results',
    path: '/sources/search',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'sources-search' },
    ]
  },
  {
    id: 6,
    name: 'card',
    path: '/manage-texts/card',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'manage-texts', link: '/manage-texts' },
    ]
  },
  {
    id: 7,
    name: 'about',
    path: '/about',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'about' },
    ]
  },
  {
    id: 20,
    name: 'themes',
    path: '/themes',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'themes' },
    ]
  },
  {
    id: 8,
    name: 'elabo',
    path: '/elabo',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'elabo' },
    ]
  },
  {
    id: 9,
    name: 'policy',
    path: '/policy',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'policy' },
    ]
  },
  {
    id: 10,
    name: 'texts',
    path: '/texts/item',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'texts', link: '/texts' },
    ]
  },
  {
    id: 11,
    name: 'users',
    path: '/users-account',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'users.account' },
    ]
  },
  {
    id: 12,
    name: 'results',
    path: '/results',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'results' },
    ]
  },
  {
    id: 15,
    name: 'sitemap',
    path: '/sitemap',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'sitemap' },
    ]
  },
  {
    id: 16,
    name: 'import-others',
    path: '/import-others',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'import-others' },
    ]
  },

  {
    id: 20,
    name: 'annotation-texts',
    path: '/annotation',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'annotation' },
    ]
  },
  {
    id: 21,
    name: 'annotation-sentences',
    path: '/annotation/sentences',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'annotation', link: '/annotation' },
    ]
  },
  {
    id: 22,
    name: 'annotation-editor',
    path: '/annotation/editor',
    list: [
      { id: 1, name: 'main', link: '/' },
      { id: 2, name: 'panel' },
      { id: 3, name: 'annotation', link: '/annotation' },
    ]
  },
]
